import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BaseTableService } from '@shared/base/base-table-service.service';
import { TableColumn } from '@shared/interface/table.interface';
import { BaseDatasource } from '@shared/base/base.datasource';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { Sort } from '@angular/material/sort';
import { IQueryParams } from '@shared/interface/urlparam.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { UrlUtilsService } from '@utils/url-utils.service';
import { UtilitiesService } from '@services/utilities.service';
import { FilterService } from '@services/filter.service';
import { API } from '@config/constants/api.constant';
import { getLastSalesOrderTableColumns } from '../../../distributor.data';
import { ILastSalesOrderProduct } from '../../../interfaces/detail-pending-non-active.interface';

@Component({
  selector: 'app-last-sales-order',
  templateUrl: './last-sales-order.component.html',
  styleUrls: ['./last-sales-order.component.scss'],
})
export class LastSalesOrderComponent implements OnInit {
  @Input() title: string = 'Sales Order';

  id: string = '';
  baseTable: BaseTableService<ILastSalesOrderProduct> = this.base;
  salesOrderList: ILastSalesOrderProduct[];
  tableColumns: TableColumn[];
  displayedColumns: string[];

  baseDatasource: BaseDatasource<ILastSalesOrderProduct>;

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private base: BaseTableService<ILastSalesOrderProduct>,
    private paginationService: UrlUtilsService,
    public utilities: UtilitiesService,
    private filterService: FilterService,
    private ref: ChangeDetectorRef
  ) {
    this.id = this.activeRoute.snapshot.paramMap.get('id') ?? '';
  }

  ngOnInit(): void {
    this.baseTable.responseDatabase.subscribe((response) => (this.baseDatasource = response));
    this.setTableData();
    this.queryHandler();
    this.initPageInfo();
  }

  initPageInfo() {
    this.baseDatasource.tableSubject.subscribe({
      next: (data) => {
        this.salesOrderList = data;
      },
    });
  }

  setTableData() {
    this.tableColumns = getLastSalesOrderTableColumns();
    this.displayedColumns = this.tableColumns.map((head) => head.key);
    this.baseDatasource = new BaseDatasource();
    if (this.salesOrderList) {
      this.baseDatasource.tableSubject.next(this.salesOrderList);
    }
  }

  sortTable(param: Sort) {
    const sortBy = this.tableColumns.find((column) => column.key === param.active);
    param.active = sortBy?.key ?? '';
    this.sortDataSource(param);
  }

  sortDataSource(sortParams: Sort) {
    if (sortParams.direction) {
      const dataParams: IQueryParams = {
        sort: sortParams.active + ',' + sortParams.direction,
      };
      this.router
        .navigate([], {
          queryParams: {
            ...dataParams,
          },
          queryParamsHandling: 'merge',
        })
        .then();
    } else {
      const snapshot = this.activeRoute.snapshot;
      const dataParam = { ...snapshot.queryParams };
      delete dataParam.sort;
      this.router.navigate([], { queryParams: dataParam }).then(() => null);
    }
  }

  queryHandler() {
    this.activeRoute.queryParams.subscribe((_) => {
      const param = this.paginationService.sliceQueryParams();
      this.baseTable.loadDataTable(API.DISTRIBUTOR.GET_LAST_SALES_ORDER + this.id, param ? param : '');
      this.filterService.filterCountList(this.baseDatasource, 'List Sales Order');
      this.ref.detectChanges();
    });
  }

  changePageEvent($event: BaseDatasource<any>) {
    this.filterService.changePageEvent($event, '');
  }

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
